module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-wedding-ceremony-ad300af1ed986debfaf78a1410f7b8b7.png";